












import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialRequestForm from '@/components/forms/MaterialRequestForm.vue';
import MaterialForm from '@/classes/MaterialForm';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        MaterialRequestForm
    }
})
export default class RequestView extends Vue {
    public $refs!: {
        materialRequestForm: MaterialRequestForm
    };

    @Prop() public id!: number;

    public get materialForm(): MaterialForm | undefined {
        if (this.id !== undefined && !isNaN(this.id)) {
            return this.$store.getters['material/getMaterialFormById'](this.id);
        } else {
            return undefined;
        }
    }
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.materialRequestForm.updateForm();
            next();
    }
}
